import {
  colorConstCommon,
  statusColorOption,
  intransitColors
} from '@fareye/configs'
export const vehicleMetrics = ['#D2D2D2', '#C81C1C', '#E4B745']
export const vehicleCountColors = {
  ...statusColorOption
}
export const labelColor = {
  ...colorConstCommon
}
export default {
  ...intransitColors
}
